import { render } from "./TimeOut.vue?vue&type=template&id=2257ef50"
import script from "./TimeOut.vue?vue&type=script&lang=js"
export * from "./TimeOut.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__